import * as React from 'react';

export interface ConceptsState {
  data: {
    [key: string]: any[];
  };
}

export interface ConceptsFeedbackState {
  data: {
    [key: string]: any;
  };
}

interface ConceptsFeedbackProps {
  concepts: ConceptsState;
  conceptsFeedback: ConceptsFeedbackState;
  fillInTheBlank?: boolean;
}

export const ConceptsFeedback = ({ concepts, conceptsFeedback, fillInTheBlank, }: ConceptsFeedbackProps) => {
  const renderConceptsFeedback = () => {
    const { data } = concepts;

    const dataArray = data[0] || data['0'];

    if (dataArray) {
      return (
        <table>
          <thead>
            <tr>
              <th>Writing Concept</th>
            </tr>
          </thead>
          <tbody>
            {dataArray
              .sort((a: any, b: any) => a.displayName.localeCompare(b.displayName))
              .map((concept: any) => {
                const hasFeedback = !!conceptsFeedback.data[concept.uid];
                return (
                  <tr key={concept.uid}>
                    <td className={hasFeedback ? '' : 'red'}><a href={`${window.location.href}/${concept.uid}`}>{concept.displayName}</a></td>
                  </tr>
                )
              })}
          </tbody>
        </table>
      )
    }

    return null;
  };

  return (
    <section className="tool-concepts">
      <h1>{fillInTheBlank ? 'Fill in the Blank ' : ''}Concepts Feedback</h1>
      {renderConceptsFeedback()}
    </section>
  );

}
